import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import LocalAuthority from "@/components/LocalAuthority";
import LuxuryHeroSlider from "@/components/LuxuryHeroSlider";
import GoogleMap from "@/components/GoogleMap";
import LandingContact from "@/components/LandingContact";
import FleetShowcase from "@/components/FleetShowcase";

import TrustSignals from "@/components/TrustSignals";
import SafetyProtocols from "@/components/SafetyProtocols";
import OptimizedImage from "@/components/OptimizedImage";
import InstantQuoteCTA from "@/components/InstantQuoteCTA";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { ArrowRight, Car, Clock, Shield, Users, Phone, Star, Gem, Wine, Building2, Heart, Navigation, Award, Medal } from "lucide-react";
import { Link } from "react-router-dom";

import SEO from "@/components/SEO";

// Standard image imports
import audiSunsetImg from "@/assets/audi-sunset.jpg";
import specializedServicesImg from "@/assets/specialized-services.png";
import specializedServicesVideo from "@/assets/specialized-services-cinematic.mp4.asset.json";
import audiDowntownNightImg from "@/assets/audi-downtown-night.png";
import audiDowntownNightVideo from "@/assets/audi-downtown-night.mp4.asset.json";
import audiHotelEmmaImg from "@/assets/audi-hotel-emma.png";
import audiHotelEmmaVideo from "@/assets/audi-hotel-emma-cinematic.mp4.asset.json";
import premierServiceImg from "@/assets/premier-service.png";
import satAirportEntranceImg from "@/assets/audi-q7-black-optic-suv.png";
import satAirportEntranceVideo from "@/assets/sat-airport-audi-q7-cinematic-v3.mp4.asset.json";
import boutiqueServiceImg from "@/assets/boutique-service.webp";

// Responsive srcset imports for optimized loading
import audiSunsetSrcset from "@/assets/audi-sunset.jpg?responsive";
import specializedServicesSrcset from "@/assets/specialized-services.png?responsive";
import audiDowntownNightSrcset from "@/assets/audi-downtown-night.png?responsive";
import audiHotelEmmaSrcset from "@/assets/audi-hotel-emma.png?responsive";
import premierServiceSrcset from "@/assets/premier-service.png?responsive";
import satAirportEntranceSrcset from "@/assets/sat-airport-entrance.jpeg?responsive";
import boutiqueServiceSrcset from "@/assets/boutique-service.webp?responsive";
const Index = () => {

  const stats = [{
    value: "5 +",
    label: "Years of Excellence"
  }, {
    value: "Exceptional",
    label: "5 Star Google Reviews"
  }];
  const services = [{
    icon: <Car className="w-8 h-8" />,
    title: "Airport Transportation",
    description: "Professional airport transfers to and from San Antonio International Airport (SAT) and Austin-Bergstrom International Airport (AUS) in our 2025 Audi Q7 luxury black SUV. Flight tracking, meet and greet service, and stress-free travel starting at just $85. Perfect for business travelers and leisure guests who demand reliability and comfort.",
    hash: "airport-transfers",
    link: "/airport-transportation"
  }, {
    icon: <Shield className="w-8 h-8" />,
    title: "JBSA Military Base Access & Vetted Chauffeur Service",
    description: "Unlike standard livery services, Rick's Black Car Service chauffeurs undergo specific vetting and registration to ensure reliable JBSA Military Base Access. Whether you are traveling to Lackland AFB, Fort Sam Houston, Randolph AFB, or Camp Bullis, our professional drivers guarantee a seamless and secure entry in the 2025 Audi Q7 luxury black SUV. Essential for military personnel, VIP visitors, and government contractors.",
    hash: "jbsa-access",
    link: "/jbsa-military-transportation"
  }, {
    icon: <Shield className="w-8 h-8" />,
    title: "Lackland AFB Graduation Transportation",
    description: "Veteran-owned by a 22-year U.S. Army retiree. Verified DBIDS base access for BMT Graduation weekends at Lackland—Coin Ceremony, Retreat, and the family Parade. Full-weekend hourly packages in the 2025 Audi Q7 luxury black SUV that stay with your family from the airport to the parade grounds and back.",
    hash: "military-graduation",
    link: "/military-graduation-transportation"
  }, {
    icon: <Building2 className="w-8 h-8" />,
    title: "Corporate Transportation",
    description: "Executive black car service for San Antonio's business professionals in our 2025 Audi Q7 luxury black SUV. Impress clients, arrive on time for important meetings, and travel in sophisticated comfort. Corporate account options available for companies seeking consistent, reliable transportation solutions.",
    hash: "corporate-travel",
    link: "/services/corporate-travel"
  }, {
    icon: <Shield className="w-8 h-8" />,
    title: "Special Events Transportation",
    description: "Arrive in style for weddings, proms, anniversaries, concerts at the AT&T Center, sporting events at the Alamodome, or nights out in downtown San Antonio. Our 2025 Audi Q7 luxury black SUV accommodates up to 6 passengers for your special occasions.",
    hash: "special-events",
    link: "/services/special-events"
  }, {
    icon: <Heart className="w-8 h-8" />,
    title: "Wedding Transportation",
    description: "Elegant bridal transportation in our 2025 Audi Q7 Black Optic SUV. Serving San Antonio, Boerne, and Hill Country venues. Flexible hourly packages designed around your ceremony, photos, and reception timeline.",
    hash: "wedding-transportation",
    link: "/wedding-transportation"
  }, {
    icon: <Clock className="w-8 h-8" />,
    title: "Hourly & As-Directed Service",
    description: "Flexible hourly black car service in the 2025 Audi Q7 luxury black SUV for multiple stops, business meetings throughout San Antonio, or personal errands. Your professional chauffeur is at your service for as long as you need.",
    hash: "hourly-services",
    link: "/services/hourly-service"
  }, {
    icon: <Wine className="w-8 h-8" />,
    title: "Wine Tours",
    description: "Experience the beauty of Texas Hill Country and Fredericksburg wine country in our 2025 Audi Q7 luxury black SUV. Relax and enjoy the scenery while we handle the driving. Perfect for couples, small groups, and wine enthusiasts.",
    hash: "winery-tours",
    link: "/wine-tours"
  }, {
    icon: <Car className="w-8 h-8" />,
    title: "San Antonio to Austin Car Service",
    description: "Executive door-to-door transport from San Antonio to Austin and AUS airport. WiFi-equipped 2025 Audi Q7 luxury black SUV—work productively while we handle I-35. Ideal for business travel, F1 Austin, and SXSW.",
    hash: "san-antonio-to-austin",
    link: "/san-antonio-to-austin"
  }, {
    icon: <Heart className="w-8 h-8" />,
    title: "Funeral & Bereavement Transportation",
    description: "Compassionate, dignified transportation during life's most difficult moments. Authorized JBSA access for Fort Sam Houston National Cemetery. Low-profile luxury in our 2025 Audi Q7 luxury black SUV—a respectful alternative to traditional limousines.",
    hash: "funeral-transportation",
    link: "/services/funeral-transportation"
  }];
  const vehicles = [{
    name: "2025 Audi Q7",
    type: "Premium Luxury SUV",
    price: "$150-175/hour",
    image: "https://images.unsplash.com/photo-1606664515524-ed2f786a0bd6?w=800&q=80"
  }];
  
  return <div className="min-h-screen w-full overflow-x-hidden">
        <SEO 
          title="Rick's Black Car Service | San Antonio Airport Transfers"
          description="Premium black car service in San Antonio, TX. Professional chauffeurs, 2025 Audi Q7 luxury SUV, SAT airport transfers, corporate travel & events. Available 24/7."
          canonicalPath="/"
        schema={[
        {
          "@context": "https://schema.org",
          "@type": "VideoObject",
          "name": "Rick's Black Car Service - Premium Luxury Transportation in San Antonio",
          "description": "Experience Rick's Black Car Service luxury fleet featuring the 2025 Audi Q7. Professional airport transfers, corporate travel, and special event transportation in San Antonio and Hill Country.",
          "thumbnailUrl": "https://ricksblackcarservicesantonio.com/og-image.jpg",
          "uploadDate": "2024-01-15T00:00:00Z",
          "contentUrl": "https://ricksblackcarservicesantonio.com/hero-video.mp4",
          "embedUrl": "https://ricksblackcarservicesantonio.com",
          "duration": "PT30S",
          "publisher": {
            "@type": "Organization",
            "name": "Rick's Black Car Service",
            "logo": {
              "@type": "ImageObject",
              "url": "https://ricksblackcarservicesantonio.com/og-image.jpg",
              "width": 1200,
              "height": 630
            }
          }
        },
        {
          "@context": "https://schema.org",
          "@type": "Organization",
          "@id": "https://ricksblackcarservicesantonio.com#organization",
          "name": "Rick's Black Car Service",
          "alternateName": "Rick's Black Car Service San Antonio",
          "url": "https://ricksblackcarservicesantonio.com",
          "logo": {
            "@type": "ImageObject",
            "url": "https://ricksblackcarservicesantonio.com/og-image.jpg",
            "width": 1200,
            "height": 630
          },
          "image": "https://ricksblackcarservicesantonio.com/og-image.jpg",
          "description": "Rick's Black Car Service is San Antonio's premier luxury transportation provider, specializing in SAT airport transfers, corporate travel, wedding transportation, and Hill Country wine tours. Family-owned and operated with over 5 years of professional service.",
          "foundingDate": "2019",
          "slogan": "Rated #1 Luxury Airport Transfer in San Antonio",
          "email": "ricksblackcarservice@outlook.com",
          "telephone": "+1-210-296-7409",
          "contactPoint": [
            {
              "@type": "ContactPoint",
              "telephone": "+1-210-296-7409",
              "contactType": "Customer Service",
              "email": "ricksblackcarservice@outlook.com",
              "areaServed": ["US", "TX"],
              "availableLanguage": ["English"],
              "contactOption": "TollFree"
            },
            {
              "@type": "ContactPoint",
              "telephone": "+1-210-296-7409",
              "contactType": "Reservations",
              "email": "ricksblackcarservice@outlook.com",
              "areaServed": "TX",
              "availableLanguage": ["English"],
              "hoursAvailable": {
                "@type": "OpeningHoursSpecification",
                "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
                "opens": "00:00",
                "closes": "23:59"
              }
            }
          ],
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "16034 Rough Oak Street",
            "addressLocality": "San Antonio",
            "addressRegion": "TX",
            "postalCode": "78232",
            "addressCountry": "US"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": 29.5850,
            "longitude": -98.4615
          },
          "areaServed": [
            {
              "@type": "City",
              "name": "San Antonio",
              "addressRegion": "Texas"
            },
            {
              "@type": "City",
              "name": "Boerne",
              "addressRegion": "Texas"
            },
            {
              "@type": "City",
              "name": "New Braunfels",
              "addressRegion": "Texas"
            },
            {
              "@type": "City",
              "name": "Austin",
              "addressRegion": "Texas"
            },
            {
              "@type": "City",
              "name": "Canyon Lake",
              "addressRegion": "Texas"
            },
            {
              "@type": "City",
              "name": "Seguin",
              "addressRegion": "Texas"
            },
            {
              "@type": "City",
              "name": "Lakehills",
              "addressRegion": "Texas"
            },
            {
              "@type": "City",
              "name": "Fair Oaks Ranch",
              "addressRegion": "Texas"
            }
          ],
          "sameAs": [
            "https://share.google/GtRFwnU1H9WWSjG5l"
          ],
          "hasOfferCatalog": {
            "@type": "OfferCatalog",
            "name": "Luxury Transportation Services",
            "itemListElement": [
              {
                "@type": "OfferCatalog",
                "name": "SAT Airport Transfer Services",
                "itemListElement": [
                  {
                    "@type": "Offer",
                    "itemOffered": {
                      "@type": "Service",
                      "name": "San Antonio Airport (SAT) Pickup & Drop-off",
                      "description": "Professional airport transfer service to/from San Antonio International Airport with flight tracking and meet & greet service"
                    }
                  },
                  {
                    "@type": "Offer",
                    "itemOffered": {
                      "@type": "Service",
                      "name": "Austin Airport (AUS) Transfer",
                      "description": "Long-distance airport transfer to Austin-Bergstrom International Airport with luxury Audi Q7 transportation"
                    }
                  }
                ]
              },
              {
                "@type": "OfferCatalog",
                "name": "Corporate Transportation Services",
                "itemListElement": [
                  {
                    "@type": "Offer",
                    "itemOffered": {
                      "@type": "Service",
                      "name": "Executive Business Travel",
                      "description": "Professional chauffeur service for business meetings, conferences, and corporate events"
                    }
                  },
                  {
                    "@type": "Offer",
                    "itemOffered": {
                      "@type": "Service",
                      "name": "Hourly & As-Directed Service",
                      "description": "Flexible hourly black car service for multiple stops and business needs throughout San Antonio"
                    }
                  }
                ]
              },
              {
                "@type": "OfferCatalog",
                "name": "Special Event Transportation",
                "itemListElement": [
                  {
                    "@type": "Offer",
                    "itemOffered": {
                      "@type": "Service",
                      "name": "Wedding Transportation",
                      "description": "Elegant luxury transportation for weddings, bridal parties, and special occasions in San Antonio and Hill Country"
                    }
                  },
                  {
                    "@type": "Offer",
                    "itemOffered": {
                      "@type": "Service",
                      "name": "Wine Tour Transportation",
                      "description": "Luxury wine tour service to Texas Hill Country and Fredericksburg wineries with professional chauffeur"
                    }
                  }
                ]
              }
            ]
          },
          "knowsAbout": [
            "Airport Transportation",
            "Corporate Transportation",
            "Wedding Transportation",
            "Wine Tours",
            "Luxury Black Car Service",
            "Executive Chauffeur Service",
            "SAT Airport Transfers",
            "Hill Country Transportation"
          ],
          "serviceType": [
            "Black Car Service",
            "Airport Transportation",
            "Corporate Transportation",
            "Executive Travel",
            "Wedding Transportation",
            "Wine Tours",
            "Chauffeur Service"
          ]
        }
        ]}
      />
      <Navbar />
      <main>
        <LuxuryHeroSlider />

        {/* Main H1 Heading - SEO Critical */}
        <section className="relative py-24 overflow-hidden">
          <div className="absolute inset-0">
            <OptimizedImage 
              src={premierServiceImg}
              srcSet={premierServiceSrcset}
              alt="Rick's Black Car Service luxury executive transportation with professional chauffeur in San Antonio, Texas" 
              className="w-full h-full object-cover brightness-110"
              width={1920}
              height={1080}
              priority
            />
            <div className="absolute inset-0 bg-gradient-to-b from-background/70 via-background/60 to-background/70 backdrop-blur-[2px]" />
          </div>
          <div className="container mx-auto px-4 relative z-10">
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-center text-foreground drop-shadow-lg">
              San Antonio Airport Transfers (SAT) &amp; VIP Meet-and-Greet
            </h2>
            <p className="text-center text-foreground text-lg mt-4 max-w-3xl mx-auto drop-shadow-md">
              Welcome to Rick's Black Car Service, San Antonio's trusted executive transportation specialist. With over 5 years of professional chauffeur experience, we provide premium black car service throughout San Antonio and surrounding areas in our immaculate 2025 Audi Q7 Black Optic.
            </p>
            <p className="text-center text-foreground text-lg mt-4 max-w-3xl mx-auto drop-shadow-md">
              Whether you need reliable airport transportation to San Antonio International Airport (SAT), corporate travel for business executives, special event transportation, or luxury wine tours through Texas Hill Country, Rick's Black Car Service delivers unmatched professionalism, punctuality, and personalized service.
            </p>
          </div>
        </section>

        {/* Veteran-Owned & Operated Section */}
        <section className="py-16 bg-secondary relative overflow-hidden">
          <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,transparent_0%,hsl(var(--secondary))_70%)]" />
          <div className="container mx-auto px-4 relative z-10">
            <div className="max-w-4xl mx-auto">
              <div className="flex flex-col md:flex-row items-center gap-8 p-8 md:p-10 rounded-2xl border border-primary/20 bg-background/50 backdrop-blur-sm shadow-xl">
                <div className="flex-shrink-0">
                  <div className="w-32 h-32 md:w-40 md:h-40 rounded-full bg-primary/10 border-4 border-primary/30 flex flex-col items-center justify-center text-primary shadow-[0_0_30px_rgba(212,175,55,0.15)]">
                    <Medal className="w-12 h-12 md:w-14 md:h-14 mb-1" strokeWidth={1.5} />
                    <span className="text-[10px] md:text-xs font-bold tracking-widest uppercase text-center leading-tight mt-1">Veteran<br />Owned</span>
                  </div>
                </div>
                <div className="text-center md:text-left space-y-4">
                  <span className="text-primary text-sm font-semibold tracking-wider uppercase">Service, Integrity, Excellence</span>
                  <h2 className="text-3xl md:text-4xl font-serif font-bold text-foreground">
                    Veteran-Owned & Operated
                  </h2>
                  <p className="text-muted-foreground text-lg leading-relaxed">
                    Rick's Black Car Service is proudly veteran-owned. Our founder is a 22-year U.S. Army retiree who brings the same discipline, accountability, and Army values—Loyalty, Duty, Respect, Selfless Service, Honor, Integrity, and Personal Courage—to every ride. That military mindset means precise timing, immaculate preparation, and a standard of service you can count on.
                  </p>
                  <p className="text-muted-foreground text-lg leading-relaxed">
                    From JBSA base access to late-night airport pickups, you benefit from two decades of military professionalism translated into luxury transportation. When you ride with us, you ride with someone who understands that mission accomplishment and troop welfare—taking care of people—are what matter most.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Featured Image Section */}
        <section className="py-12 luxury-gradient">
          <div className="container mx-auto px-4">
            <div className="relative w-full max-w-5xl mx-auto overflow-hidden rounded-lg shadow-2xl">
              <video
                src={audiDowntownNightVideo.url}
                poster={audiDowntownNightImg}
                className="w-full h-auto object-cover"
                width={1920}
                height={1080}
                autoPlay
                loop
                muted
                playsInline
                aria-label="Luxury Executive Car Service San Antonio Audi Q7 - downtown night skyline view"
               preload="metadata" disableRemotePlayback/>
            </div>
          </div>
        </section>

        {/* About Section */}
        <section className="py-20 luxury-gradient">
          <div className="container mx-auto px-4">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-stretch min-h-[80vh]">
              <div className="space-y-6 flex flex-col justify-center">
                <div>
                <h2 className="text-4xl md:text-5xl font-serif font-bold text-foreground">
                  Premier Executive Car Service for San Antonio Corporate Travel
                </h2>
                </div>
                
                <div className="space-y-6">
                  <div>
                    <h3 className="text-2xl font-semibold text-primary mb-3">Boutique, Personalized Service</h3>
                    <p className="text-muted-foreground text-lg leading-relaxed">
                      Unlike large fleet companies, Rick's Black Car Service offers personalized attention and consistency. You get the same immaculate 2025 Audi Q7 luxury black SUV and professional chauffeur every time—no surprises, just reliable luxury transportation.
                    </p>
                  </div>
                  
                  <div>
                    <h3 className="text-2xl font-semibold text-primary mb-3">Over 5 Years Professional Experience</h3>
                    <p className="text-muted-foreground text-lg leading-relaxed">
                      With more than 5 years of professional chauffeur experience, we understand the importance of punctuality, discretion, and exceptional service. Your safety and satisfaction are our top priorities.
                    </p>
                  </div>
                  
                  <div>
                    <h3 className="text-2xl font-semibold text-primary mb-3">Pristine 2025 Audi Q7 Black Optic</h3>
                    <p className="text-muted-foreground text-lg leading-relaxed">
                      Travel in a brand-new luxury SUV featuring premium leather seating, climate control, advanced safety features, and a smooth, quiet ride. Our vehicle is meticulously detailed before every service.
                    </p>
                  </div>
                  
                  <div>
                    <h3 className="text-2xl font-semibold text-primary mb-3">24/7 Availability</h3>
                    <p className="text-muted-foreground text-lg leading-relaxed">
                      We're available around the clock for your transportation needs. Early morning airport runs, late-night event pickups, or last-minute corporate travel—we're here when you need us.
                    </p>
                  </div>
                  
                  <div>
                    <h3 className="text-2xl font-semibold text-primary mb-3">Transparent, Competitive Pricing</h3>
                    <p className="text-muted-foreground text-lg leading-relaxed">
                      No hidden fees or surge pricing. Airport transfers start at just $85, and we provide upfront quotes for all services.
                    </p>
                  </div>
                  
                  <div>
                    <h3 className="text-2xl font-semibold text-primary mb-3">Professional & Discreet</h3>
                    <p className="text-muted-foreground text-lg leading-relaxed">
                      Whether you're conducting business calls, preparing for a meeting, or simply relaxing, we provide a professional, discreet environment.
                    </p>
                  </div>
                </div>
              </div>
              
              <div className="relative w-full h-full min-h-[500px] overflow-hidden rounded-lg shadow-2xl">
                <video
                  src={audiHotelEmmaVideo.url}
                  poster={audiHotelEmmaImg}
                  autoPlay
                  loop
                  muted
                  playsInline
                  preload="auto"
                  aria-label="Luxury Executive Car Service San Antonio Audi Q7 at Hotel Emma"
                  className="w-full h-full object-cover"
                 disableRemotePlayback/>
                <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,transparent_55%,hsl(var(--background)/0.4)_100%)] pointer-events-none" />
              </div>
            </div>
          </div>
        </section>

        {/* Stats Section */}
        <section className="py-16 bg-secondary">
          <div className="container mx-auto px-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {stats.map((stat, index) => <div key={index} className="text-center">
                  <div className="text-5xl md:text-6xl font-serif font-bold text-primary mb-2">
                    {stat.value}
                  </div>
                  <div className="text-muted-foreground text-lg">{stat.label}</div>
                </div>)}
            </div>
          </div>
        </section>

        {/* Services Section */}
        <section className="py-20 relative overflow-hidden">
          <div className="absolute inset-0 z-0">
            <div className="relative w-full h-full">
              <OptimizedImage 
                src={audiSunsetImg}
                srcSet={audiSunsetSrcset}
                alt="Luxury Executive Car Service San Antonio Audi Q7 at sunset - premium transportation services" 
                className="w-full h-full object-cover opacity-90 brightness-125"
                width={1920}
                height={1080}
              />
              <div className="absolute inset-0 bg-gradient-to-b from-background/60 via-background/70 to-background/90" />
            </div>
          </div>
          <div className="container mx-auto px-4 relative z-10">
            <div className="text-center mb-16">
              <span className="text-primary text-sm font-semibold tracking-wider uppercase drop-shadow-lg">
                Trusted Services
              </span>
              <h2 className="text-4xl md:text-5xl font-serif font-bold mt-2 text-foreground drop-shadow-lg">
                Luxury Transportation Services
              </h2>
              <p className="text-foreground/90 text-lg mt-4 max-w-2xl mx-auto drop-shadow-md">
                Experience premier black car service San Antonio with our professional chauffeur service San Antonio TX. From corporate car service San Antonio and black car service to SAT airport to executive transportation San Antonio, wedding transportation San Antonio, San Antonio River Walk car service, Spurs game car service, and Fiesta San Antonio transportation - we deliver luxury car service San Antonio tailored to your needs.
              </p>
              <Button 
                className="btn-luxury text-lg px-8 py-6 mt-6 shadow-xl" 
                asChild
              >
                <a href="https://ricksblackcarservicesantonio.square.site/" target="_blank" rel="noopener noreferrer">
                  Book Now
                  <ArrowRight className="w-5 h-5 ml-2" />
                </a>
              </Button>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {services.slice(0, -1).map((service, index) => <Card key={index} className="card-luxury hover:scale-105 transition-all duration-300 hover:shadow-2xl">
                  <CardContent className="p-8 space-y-4">
                    <div className="text-primary mb-2">{service.icon}</div>
                    <h3 className="text-xl font-semibold text-foreground">{service.title}</h3>
                    <p className="text-muted-foreground leading-relaxed">{service.description}</p>
                    {service.link ? (
                      <Button variant="outline" className="w-full btn-luxury" asChild>
                        <Link to={service.link}>
                          {['/airport-transportation', '/wedding-transportation', '/wine-tours'].includes(service.link) ? 'Learn more' : 'Book Now'} <ArrowRight className="w-4 h-4 ml-1 inline-block" />
                        </Link>
                      </Button>
                    ) : (
                      <Button variant="ghost" className="text-primary hover:text-primary/80 p-0 group" asChild>
                        <Link to={`/services#${service.hash}`}>
                          Explore {service.title} <ArrowRight className="w-4 h-4 ml-1 inline-block group-hover:translate-x-1 transition-transform" />
                        </Link>
                      </Button>
                    )}
                  </CardContent>
                </Card>)}
            </div>
            
            {/* Funeral Services - Centered */}
            <div className="flex justify-center mt-8">
              <Card className="card-luxury hover:scale-105 transition-all duration-300 max-w-md w-full border-2 border-primary/40 shadow-[0_0_20px_rgba(212,175,55,0.15)] hover:shadow-[0_0_30px_rgba(212,175,55,0.25)] hover:border-primary/60">
                <CardContent className="p-8 space-y-4">
                  <div className="text-primary mb-2">{services[services.length - 1].icon}</div>
                  <h3 className="text-xl font-semibold text-foreground">{services[services.length - 1].title}</h3>
                  <p className="text-muted-foreground leading-relaxed">{services[services.length - 1].description}</p>
                  <Button variant="outline" className="w-full btn-luxury" asChild>
                    <Link to={services[services.length - 1].link!}>
                      Book Now <ArrowRight className="w-4 h-4 ml-1 inline-block" />
                    </Link>
                  </Button>
                </CardContent>
              </Card>
            </div>
          </div>
        </section>

        {/* Specialized Services Section */}
        <section className="py-20 relative overflow-hidden">
          <div className="absolute inset-0 z-0">
            <div className="relative w-full h-full">
              <video
                src={specializedServicesVideo.url}
                poster={specializedServicesImg}
                autoPlay
                loop
                muted
                playsInline
                preload="auto"
                aria-hidden="true"
                className="w-full h-full object-cover opacity-90 brightness-125"
               disableRemotePlayback/>
              <div className="absolute inset-0 bg-gradient-to-b from-background/60 via-background/70 to-background/90" />
              <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,transparent_45%,hsl(var(--background)/0.6)_100%)]" />
            </div>
          </div>
          <div className="container mx-auto px-4 relative z-10">
            <div className="text-center mb-16">
              <span className="text-primary text-sm font-semibold tracking-wider uppercase drop-shadow-lg">
                Premium Offerings
              </span>
              <h2 className="text-4xl md:text-5xl font-serif font-bold mt-2 text-foreground drop-shadow-lg">
                Luxury Private Car Services for Weddings and Special Events
              </h2>
              <p className="text-foreground/90 text-lg mt-4 max-w-2xl mx-auto drop-shadow-md">
                Tailored transportation solutions for life's most meaningful moments and everyday excellence.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-10 max-w-5xl mx-auto mb-12">
              <Card className="card-luxury hover:scale-105 transition-all duration-300 hover:shadow-2xl">
                <CardContent className="p-10 space-y-6 flex flex-col items-center text-center">
                  <div className="text-primary">
                    <Heart className="w-12 h-12 stroke-[1.5]" />
                  </div>
                  <h3 className="text-2xl font-serif font-bold text-foreground">Funeral Services</h3>
                  <p className="text-muted-foreground leading-relaxed">
                    Compassionate and dignified transportation for memorials, processions, and family gatherings during difficult times.
                  </p>
                  <Button asChild className="btn-luxury mt-4">
                    <Link to="/services/funeral-transportation">
                      Book Now <ArrowRight className="w-4 h-4 ml-1 inline-block" />
                    </Link>
                  </Button>
                </CardContent>
              </Card>

              <Card className="card-luxury hover:scale-105 transition-all duration-300 hover:shadow-2xl">
                <CardContent className="p-10 space-y-6 flex flex-col items-center text-center">
                  <div className="text-primary">
                    <Navigation className="w-12 h-12 stroke-[1.5]" />
                  </div>
                  <h3 className="text-2xl font-serif font-bold text-foreground">Point to Point Travel</h3>
                  <p className="text-muted-foreground leading-relaxed">
                    Reliable, direct transportation between any two locations, perfect for business trips, events, or everyday commutes.
                  </p>
                  <Button asChild className="btn-luxury mt-4">
                    <Link to="/contact">
                      Book Now <ArrowRight className="w-4 h-4 ml-1 inline-block" />
                    </Link>
                  </Button>
                </CardContent>
              </Card>
            </div>

            <div className="text-center">
              <Button asChild size="lg" className="btn-luxury text-lg px-10 py-6 shadow-xl hover:shadow-2xl">
                <Link to="/services">
                  View All Services <ArrowRight className="w-5 h-5 ml-2" />
                </Link>
              </Button>
            </div>
          </div>
        </section>

        {/* Airports We Serve Section */}
        <section className="py-20 relative overflow-hidden">
          <div className="absolute inset-0 z-0">
            <div className="relative w-full h-full">
              <video
                src={satAirportEntranceVideo.url}
                poster={satAirportEntranceImg}
                autoPlay
                loop
                muted
                playsInline
                preload="auto"
                aria-hidden="true"
                className="w-full h-full object-cover brightness-110"
               disableRemotePlayback/>
              <div className="absolute inset-0 bg-gradient-to-b from-background/60 via-background/50 to-background/70" />
              <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,transparent_45%,hsl(var(--background)/0.6)_100%)]" />
            </div>
          </div>
          <div className="container mx-auto px-4 relative z-10">
            <div className="text-center mb-12">
              <span className="text-primary text-sm font-semibold tracking-wider uppercase drop-shadow-lg">
                San Antonio Airport Transportation
              </span>
              <h2 className="text-4xl md:text-5xl font-serif font-bold mt-2 text-foreground drop-shadow-lg">
                Black Car Service to SAT Airport | Airport Limo Service
              </h2>
              <p className="text-foreground/90 text-lg mt-4 max-w-2xl mx-auto drop-shadow-md">
                Professional black car service to SAT airport with flight tracking, meet & greet, and 24/7 availability. Our San Antonio airport car service, SAT airport limo service, and chauffeur service San Antonio TX ensures timely arrivals and departures for all executive transportation San Antonio needs.
              </p>
              <Button 
                className="btn-luxury text-lg px-8 py-6 mt-6 shadow-xl" 
                asChild
              >
                <Link to="/airport-transfer-san-antonio-sat">
                  Learn About SAT Airport Service
                  <ArrowRight className="w-5 h-5 ml-2" />
                </Link>
              </Button>
            </div>
          </div>
        </section>


        {/* Service Areas Section */}
        <section className="py-20 luxury-gradient">
          <div className="container mx-auto px-4">
            <div className="text-center mb-12">
              <span className="text-primary text-sm font-semibold tracking-wider uppercase">
                Our Coverage
              </span>
              <h2 className="text-4xl md:text-5xl font-serif font-bold mt-2 text-foreground">
                Serving San Antonio and Surrounding Areas
              </h2>
              <p className="text-muted-foreground text-lg mt-4 max-w-3xl mx-auto">
                Premier black car service San Antonio covering all major neighborhoods, landmarks, and nearby cities. Our luxury car service San Antonio reaches every corner of the greater metro area.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto mb-12">
              {/* Premium Neighborhoods */}
              <Card className="card-luxury">
                <CardContent className="p-8">
                  <div className="flex items-center gap-3 mb-6">
                    <Building2 className="w-8 h-8 text-primary" />
                    <h3 className="text-2xl font-serif font-bold text-foreground">Premium Neighborhoods</h3>
                  </div>
                  <ul className="space-y-3 text-muted-foreground">
                    <li className="flex items-start gap-2">
                      <span className="text-primary mt-1">•</span>
                      <span>Alamo Heights</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-primary mt-1">•</span>
                      <span>Stone Oak</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-primary mt-1">•</span>
                      <span>The Dominion</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-primary mt-1">•</span>
                      <span>Terrell Hills</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-primary mt-1">•</span>
                      <span>Downtown San Antonio</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-primary mt-1">•</span>
                      <span>Medical Center</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-primary mt-1">•</span>
                      <span>Airport Area</span>
                    </li>
                  </ul>
                </CardContent>
              </Card>

              {/* Nearby Cities */}
              <Card className="card-luxury">
                <CardContent className="p-8">
                  <div className="flex items-center gap-3 mb-6">
                    <Navigation className="w-8 h-8 text-primary" />
                    <h3 className="text-2xl font-serif font-bold text-foreground">Nearby Cities</h3>
                  </div>
                  <ul className="space-y-3 text-muted-foreground">
                    <li className="flex items-start gap-2">
                      <span className="text-primary mt-1">•</span>
                      <span>Boerne</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-primary mt-1">•</span>
                      <span>New Braunfels</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-primary mt-1">•</span>
                      <span>Schertz</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-primary mt-1">•</span>
                      <span>Universal City</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-primary mt-1">•</span>
                      <span>Canyon Lake</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-primary mt-1">•</span>
                      <span>Fair Oaks Ranch</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-primary mt-1">•</span>
                      <span>Seguin</span>
                    </li>
                  </ul>
                </CardContent>
              </Card>

              {/* Popular Landmarks */}
              <Card className="card-luxury">
                <CardContent className="p-8">
                  <div className="flex items-center gap-3 mb-6">
                    <Star className="w-8 h-8 text-primary" />
                    <h3 className="text-2xl font-serif font-bold text-foreground">Popular Landmarks</h3>
                  </div>
                  <ul className="space-y-3 text-muted-foreground">
                    <li className="flex items-start gap-2">
                      <span className="text-primary mt-1">•</span>
                      <span>San Antonio River Walk</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-primary mt-1">•</span>
                      <span>Pearl District</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-primary mt-1">•</span>
                      <span>La Cantera</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-primary mt-1">•</span>
                      <span>The Rim</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-primary mt-1">•</span>
                      <span>The Alamo</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-primary mt-1">•</span>
                      <span>Convention Center</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="text-primary mt-1">•</span>
                      <span>AT&T Center</span>
                    </li>
                  </ul>
                </CardContent>
              </Card>
            </div>

            <div className="text-center">
              <p className="text-muted-foreground text-lg mb-6 max-w-3xl mx-auto">
                Rick's Black Car Service proudly serves San Antonio and surrounding areas including: Downtown, Alamo Heights, Stone Oak, The Dominion, Medical Center, Terrell Hills, Olmos Park, Boerne, New Braunfels, Schertz, Cibolo, Helotes, and all greater San Antonio communities. We also serve Texas Hill Country, Fredericksburg, and <Link to="/san-antonio-to-austin" className="text-primary hover:underline">Austin</Link>.
              </p>
              <Button asChild className="btn-luxury text-lg px-8 py-6">
                <Link to="/service-areas">
                  View All Service Areas <ArrowRight className="w-5 h-5 ml-2" />
                </Link>
              </Button>
            </div>
          </div>
        </section>

        {/* Google Map Section */}
        <GoogleMap />

        {/* Fleet Showcase Section */}
        <FleetShowcase />

        {/* Trust Signals Section */}
        <TrustSignals />

        {/* Safety Protocols Section */}
        <SafetyProtocols />


        {/* Landing Contact Section */}
        <LandingContact />

        {/* Blog Section - Military Transportation Featured */}
        <section className="py-20 bg-muted/30">
          <div className="container mx-auto px-4">
            <div className="text-center mb-12">
              <span className="text-primary text-sm font-semibold tracking-wider uppercase">
                Featured Guides
              </span>
              <h2 className="text-4xl md:text-5xl font-serif font-bold text-foreground mb-4 mt-2">
                From Our Blog
              </h2>
              <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
                Expert guides for military families and personnel traveling to JBSA installations
              </p>
            </div>
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto mb-10">
              {/* Featured: What is JBSA Access */}
              <Card className="card-luxury hover:scale-105 transition-transform duration-300 group border-primary/30">
                <CardContent className="p-6">
                  <span className="text-xs text-blue-400 font-semibold uppercase tracking-wider">Featured Guide</span>
                  <h3 className="text-xl font-serif font-bold mb-3 text-foreground mt-2">
                    What is JBSA Access? Complete Guide
                  </h3>
                  <p className="text-muted-foreground mb-4 text-sm">
                    Everything you need to know about JBSA base access, requirements, and why it matters.
                  </p>
                  <Link 
                    to="/blog/what-is-jbsa-access-guide" 
                    className="text-primary hover:underline font-medium inline-flex items-center gap-1 group-hover:gap-2 transition-all"
                  >
                    Read Guide <ArrowRight className="w-4 h-4" />
                  </Link>
                </CardContent>
              </Card>
              <Card className="card-luxury hover:scale-105 transition-transform duration-300 group">
                <CardContent className="p-6">
                  <span className="text-xs text-primary font-semibold uppercase tracking-wider">Lackland AFB</span>
                  <h3 className="text-xl font-serif font-bold mb-3 text-foreground mt-2">
                    BMT Graduation Transportation Guide
                  </h3>
                  <p className="text-muted-foreground mb-4 text-sm">
                    Essential tips for families attending Basic Military Training graduation.
                  </p>
                  <Link 
                    to="/blog/bmt-graduation-transportation-guide-lackland-afb" 
                    className="text-primary hover:underline font-medium inline-flex items-center gap-1 group-hover:gap-2 transition-all"
                  >
                    Read Guide <ArrowRight className="w-4 h-4" />
                  </Link>
                </CardContent>
              </Card>
              <Card className="card-luxury hover:scale-105 transition-transform duration-300 group">
                <CardContent className="p-6">
                  <span className="text-xs text-primary font-semibold uppercase tracking-wider">Fort Sam Houston</span>
                  <h3 className="text-xl font-serif font-bold mb-3 text-foreground mt-2">
                    BAMC Medical Appointment Transportation
                  </h3>
                  <p className="text-muted-foreground mb-4 text-sm">
                    Guide to Fort Sam Houston and Brooke Army Medical Center transportation.
                  </p>
                  <Link 
                    to="/blog/fort-sam-houston-bamc-medical-appointment-transportation" 
                    className="text-primary hover:underline font-medium inline-flex items-center gap-1 group-hover:gap-2 transition-all"
                  >
                    Read Guide <ArrowRight className="w-4 h-4" />
                  </Link>
                </CardContent>
              </Card>
              <Card className="card-luxury hover:scale-105 transition-transform duration-300 group">
                <CardContent className="p-6">
                  <span className="text-xs text-primary font-semibold uppercase tracking-wider">Randolph AFB</span>
                  <h3 className="text-xl font-serif font-bold mb-3 text-foreground mt-2">
                    Randolph AFB Transportation Guide
                  </h3>
                  <p className="text-muted-foreground mb-4 text-sm">
                    Professional car service for military personnel at Randolph Air Force Base.
                  </p>
                  <Link 
                    to="/blog/randolph-afb-transportation-guide" 
                    className="text-primary hover:underline font-medium inline-flex items-center gap-1 group-hover:gap-2 transition-all"
                  >
                    Read Guide <ArrowRight className="w-4 h-4" />
                  </Link>
                </CardContent>
              </Card>
            </div>
            <div className="text-center">
              <Button asChild className="btn-luxury text-lg px-8 py-6">
                <Link to="/blog">
                  View All Blog Posts <ArrowRight className="ml-2 h-5 w-5" />
                </Link>
              </Button>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-20 relative overflow-hidden">
          <div className="absolute inset-0 z-0">
            <div className="relative w-full h-full">
              <OptimizedImage 
                src={boutiqueServiceImg}
                srcSet={boutiqueServiceSrcset}
                alt="Rick's Black Car Service boutique luxury transportation with personalized white-glove service in San Antonio" 
                className="w-full h-full object-cover brightness-110"
                width={1920}
                height={1080}
              />
              <div className="absolute inset-0 bg-gradient-to-b from-background/70 via-background/60 to-background/70 backdrop-blur-[2px]" />
            </div>
          </div>
          <div className="container mx-auto px-4 relative z-10">
            <div className="max-w-4xl mx-auto text-center space-y-8">
              <h2 className="text-4xl md:text-5xl font-serif font-bold text-foreground drop-shadow-lg">
                Experience the Difference of True Boutique Black Car Service
              </h2>
              <p className="text-foreground/90 text-lg drop-shadow-md">
                Call (210) 296-7409 or book online today. Available 24/7.
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                <Button className="btn-luxury text-lg px-8 py-6" asChild>
                  <a href="tel:+12102967409">
                    <Phone className="w-5 h-5 mr-2" />
                    Call Now: 210-296-7409
                  </a>
                </Button>
                <Button 
                  variant="outline" 
                  className="text-lg px-8 py-6 border-primary text-primary hover:bg-primary hover:text-primary-foreground"
                  asChild
                >
                  <a href="https://ricksblackcarservicesantonio.square.site/" target="_blank" rel="noopener noreferrer">
                    Book Online
                  </a>
                </Button>
              </div>
            </div>
          </div>
        </section>

        {/* Instant Quote CTA */}
        <InstantQuoteCTA />
        <LocalAuthority />
      </main>
      <Footer />
    </div>;
};
export default Index;